import { useMutation } from "@apollo/client";

import { MapEditorPlannerAreaPanel_PlannerAreaMediaRemoveMediaDocument } from "../../mutations.generated";
import { MapEditorPlannerAreaPanelDocument } from "../../queries.generated";

export function useDeletePlannerAreaMediaMutation() {
    const [mutate, result] = useMutation(MapEditorPlannerAreaPanel_PlannerAreaMediaRemoveMediaDocument, {
        refetchQueries: [MapEditorPlannerAreaPanelDocument],
    });

    const deletePlannerAreaMedia = (plannerAreaId: string, mediaId: string) =>
        mutate({
            variables: { input: { plannerAreaId, mediaId } },
        });

    return [deletePlannerAreaMedia, result] as const;
}
